import { Component, ComponentRef, OnInit, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { ConfirmationMessageFragment } from 'src/app/fragments/modal/confirmation-message/confirmation-message.fragment';
import { AnnuaireProfessionnelsSanteService } from 'src/app/services/annuaire-professionnels-sante/annuaire-professionnels-sante.service';
import { CguService, CguSignataireDecision, DecisionStateEnum, HistoriqueCguSignataireDecision } from 'src/app/services/cgu/cgu.service';
import { FeatureType } from 'src/app/services/feature/feature.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { ProfilService } from 'src/app/services/profil/profil.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { RoleService } from 'src/app/services/role/role.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { UserService } from 'src/app/services/user/user.service';
import { EMAIL_REGEX } from 'src/app/utils/constante';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Cabinet } from 'src/app/utils/interfaces/new/cabinet.interface';
import { CreateProfil } from 'src/app/utils/interfaces/new/create-profil.interface';
import { CreateUtilisateur } from 'src/app/utils/interfaces/new/create-utilisateur.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { InfoAnnuaire, InfoAnnuaireExtend } from 'src/app/utils/interfaces/new/info-annuaire.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { Referentiel } from 'src/app/utils/interfaces/new/referentiel.interface';
import { Role } from 'src/app/utils/interfaces/new/role.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';

const PROFESSION_OID = '1.2.250.1.71.1.2.7';
const PROFESSION_FORMATION_OID = '1.2.250.1.71.1.2.8';
const SPECIALITE_OID = '1.2.250.1.71.4.2.5';

interface NgSelectValue {
  id: string;
  libelle: string;
}

interface CguSignataireDecisionCustom extends CguSignataireDecision {
  decisionStateLabel?: string;
}

interface HistoriqueCguSignataireDecisionCustom extends HistoriqueCguSignataireDecision {
  decisionStateLabel?: string;
  decisionDateStr?: string;
}

@Component({
  selector: 'app-user-creation',
  templateUrl: './user-creation.component.html',
  styleUrls: ['./user-creation.component.scss']
})
export class UserCreationComponent implements OnInit {

  // rpps?: string;
  //   nom?: string;
  //   prenom?: string;
  //   adresse?: string;
  //   codePostal?: string;
  //   commune?: string;
  //   telephone?: string;
  //   email?: string;
  //   emailMSS?: string[];
  //   titre?: string;
  //   specialite?: string;

  annuaireColumnTable = [
    { title: 'RPPS', data: 'rpps', isEditable: false},
    { title: 'Nom', data: 'nom', isEditable: false},
    { title: 'Prénom', data: 'prenom', isEditable: false},
    { title: 'Catégorie', data: 'categorie', isEditable: false},
    { title: 'Ville', data: 'ville', isEditable: false},
    { title: 'Code postal', data: 'codePostal', isEditable: false},
    { title: 'Adresse', data: 'adresse', isEditable: false},
    { title: 'Téléphone', data: 'telephone', isEditable: false},
    { title: 'Email', data: 'email', isEditable: false},
  ];

  public userForm: FormGroup;
  public formControlInput: FormControl;
  public isAdminMode: boolean;
  public qualiteValue: NgSelectValue[] = [];
  public specialiteValue: NgSelectValue[] = [];
  public roles: Role[];
  public idUtilisateur = '';
  public idCabinet: string;
  public cabinet: Cabinet;
  private profilId: string;
  public user: Utilisateur;
  public rppsInfo: InfoAnnuaireExtend;
  isInRppsSearching: boolean;

  public isRppsFromAnn = false;
  public isQualiteFromAnn = false;
  public isSpecialiteFromAnn = false;
  public isAdresseMssFromAnn = false;
  public isNomFromAnn = false;
  public isPrenomFromAnn = false;
  public isCategorieFromAnn = false;

  get rolesFormArray(): FormArray {
    return this.userForm.controls.roles as FormArray;
  }

  public userCategories = ['Civil', 'Militaire', 'Etudiant'];

  public historiqueCgu: Array<HistoriqueCguSignataireDecisionCustom>;
  public displayedColumns: string[] = ['cguVersion','decisionDateStr','decisionState'];
  public currentCgu: CguSignataireDecisionCustom;
  public decisionStateEnum = DecisionStateEnum;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public modalService: ModalService,
    public viewContainerRef: ViewContainerRef,
    private referentielSvc: ReferentielService,
    private profilService: ProfilService,
    private roleService: RoleService,
    private userService: UserService,
    private cabinetService: CabinetService,
    private _strUtilsSrv: StringUtilsService,
    private _annSrv: AnnuaireProfessionnelsSanteService,
    private _cguSrv: CguService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.idCabinet = this.route.snapshot.params.idCabinet;
    this.cabinet = await this.cabinetService.findOne(this.idCabinet);
    this.qualiteValue = await (await this.referentielSvc.findRefListTableHypermed(ReferentielEnum.subjectrole_dmp))
      .map((qualite) => { return { id: qualite.id, libelle: qualite.libelle } });
    this.specialiteValue = this.qualiteValue
    if (this.route.snapshot.params.idCabinet) {
      // Mode User
      this.isAdminMode = false;
      if (this.route.snapshot.params.id) {
        this.userForm = this.formBuilder.group({
          rpps: [''],
          qualite: ['', Validators.required],
          specialite: ['', Validators.required],
          nom: ['', Validators.required],
          prenom: ['', Validators.required],
          roles: new FormArray([]),
          adresse: ['', Validators.required],
          codePostal: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
          ville: ['', Validators.required],
          telephone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
          email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
          actif: [true],
          adminCabinet: [false],
          emailMss: [''],
          categorie: [undefined, Validators.required]
        });
        if (this.route.snapshot.params.id) {
          const loading = this.modalService.openLoading(this.viewContainerRef);
          const profil = await this.profilService.findOne(this.route.snapshot.params.id);
          this.profilId= profil.id;
          this.user = await this.userService.findOne(profil.idUtilisateur);
          const rolesPaginated = await this.roleService.find();
          this.roles = rolesPaginated.objects;
          this.roles.map(() => this.rolesFormArray.push(new FormControl()));
          this.patchProfil(profil, this.user);
          this.modalService.close(loading);
        }
      } else {
        // Si on a le cabinet on pret remplir le formulaire avec les informations du cabinet
        this.userForm = this.formBuilder.group({
          actif: [true],
          rpps: [''],
          pseudo: ['', Validators.required],
          qualite: ['', Validators.required],
          specialite: ['', Validators.required],
          roles: new FormArray([]),
          nom: ['', Validators.required],
          prenom: ['', Validators.required],
          adresse: [this.cabinet.adresse, Validators.required],
          codePostal: [this.cabinet.codePostal, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]],
          ville: [this.cabinet.ville, Validators.required],
          telephone: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
          email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
          adminCabinet: [false],
          emailMss: [''],
          categorie: [undefined, Validators.required]
        });
        const rolesPaginated = await this.roleService.find();
        this.roles = rolesPaginated.objects;
        this.roles.map(() => this.rolesFormArray.push(new FormControl()));
      }
    } else {
      // Mode Admin
      this.isAdminMode = true;
      this.userForm = this.formBuilder.group({
        actif: [false],
        pseudo: ['', Validators.required],
        nom: ['', Validators.required],
        prenom: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
      });
      if (this.route.snapshot.params.id) {
        const loading = this.modalService.openLoading(this.viewContainerRef);
        this.user = await this.userService.findOne(this.route.snapshot.params.id);
        this.patchAdmin(this.user);
        this.modalService.close(loading);
      }
    }

    await this._initHistoriqueDecisionsCgu();
  }

  private async _initHistoriqueDecisionsCgu(): Promise<void> {
    try {
      if (this.user) {
        this.currentCgu = await this._cguSrv.getCguDecision(this.user.id);
        this.currentCgu.decisionStateLabel = this._cguSrv.getDecisionStateEnumLabel(this.currentCgu.currentCguDecisionState);

        this.historiqueCgu = [];
        const historique: Array<HistoriqueCguSignataireDecisionCustom> = await this._cguSrv.getHistoriqueCguDecision(this.user.id);
        for (const cgu of historique) {
          cgu.decisionDateStr = moment(cgu.decisionDate).format('DD-MM-YYYY à HH:mm:ss');
          cgu.decisionStateLabel = this._cguSrv.getDecisionStateEnumLabel(cgu.decisionState);
        }
        this.historiqueCgu = historique;
      }
    } catch (error) {
      console.error(error);
    }
  }

  public patchAdmin(user: Utilisateur): void {
    this.userForm.controls.pseudo.patchValue(user.pseudo);
    this.userForm.controls.nom.patchValue(user.nom);
    this.userForm.controls.prenom.patchValue(this._strUtilsSrv.uppercaseFirstCharString(user.prenom));
    this.userForm.controls.email.patchValue(user.email);
    this.userForm.controls.actif.patchValue(!user.disabled);
    this.userForm.updateValueAndValidity();
    this._setFromAnnValues(undefined, user);
  }

  /**
   * Cette fonction retire les espaces et les points d'une chaîne de caractères
   */
  private _formatTelephone(str: string): string {
    return str.replace(/\s/g, '').replace(/\./g, '');
  }

  public patchProfil(profil: Profil, user: Utilisateur): void {
    this.idUtilisateur = profil.idUtilisateur;
    this.userForm.controls.rpps.patchValue(profil.rpps ?? '')
    this.userForm.controls.qualite.patchValue(profil.qualiteCode || undefined);
    this.userForm.controls.specialite.patchValue(profil.specialiteCode || undefined);
    this.userForm.controls.nom.patchValue(user.nom || '');
    this.userForm.controls.prenom.patchValue(user.prenom ? this._strUtilsSrv.uppercaseFirstCharString(user.prenom) : '');
    this.userForm.controls.adresse.patchValue(profil.adresse || '');
    this.userForm.controls.codePostal.patchValue(profil.codePostal || '');
    this.userForm.controls.ville.patchValue(profil.ville || '');
    this.userForm.controls.telephone.patchValue(profil.telephone ? this._formatTelephone(profil.telephone) : '');
    this.userForm.controls.actif.patchValue((profil.disabled !== undefined && profil.disabled !== null) ? !profil.disabled : false);
    this.userForm.controls.adminCabinet.patchValue(profil.adminCabinet || false);
    this.userForm.controls.emailMss.patchValue(profil.adresseMss || '');
    this.userForm.controls.categorie.patchValue(user.categorie || '');
    this.userForm.controls.email.patchValue(user.email || '');
    this.patchRole(profil);
    this.userForm.updateValueAndValidity();
    this._setFromAnnValues(profil, user);
  }

  private _setFromAnnValues(profil?: Profil, user?: Utilisateur): void {
    if (profil) {
      this.isRppsFromAnn = profil.isRppsFromAnn;
      this.isQualiteFromAnn = profil.isQualiteFromAnn;
      this.isSpecialiteFromAnn = profil.isSpecialiteFromAnn;
      this.isAdresseMssFromAnn = profil.isAdresseMssFromAnn;
    }
    if (user) {
      this.isNomFromAnn = user.isNomFromAnn;
      this.isPrenomFromAnn = user.isPrenomFromAnn;
    }
  }

  /**
   * Parcoure le tableau de role (qui à été utilisé pour créer le tableau de controles rolesFormArray)
   * On cherche parmis les roles du profils, ceux qui correspondent au bon roles
   * Sachant que rolesFormArray à été créer à partir de roles, leurs index correspondent au même roles
   * Si on trouve un role, alors on patch la value à true
   */
  private patchRole(profil: Profil): void {
    for (let i = 0; i < this.roles.length; i++) {
      const roleFound = profil.roles.find((role: Role) => this.roles[i].nom === role.nom);
      if (roleFound) {
        this.rolesFormArray.controls[i].patchValue(true);
      } else {
        this.rolesFormArray.controls[i].patchValue(false);
      }
    }
  }

  public async onSubmit(): Promise<void> {
    const loader = this.modalService.openLoading(this.viewContainerRef);
    try {
      this.userForm.markAllAsTouched();
      if (this.userForm.valid) {
        let idEntity;
        if (this.isAdminMode) {
          idEntity = await this.submitAdmin();
        } else {
          idEntity = await this.submitUser();
        }
        this.modalService.close(loader);
        if (!idEntity) {
          return;
        }

        if (this.route.snapshot.params.idCabinet) {
          this.router.navigate([`administration/office-creation/${this.idCabinet}`]);
        } else {
          this.router.navigateByUrl('/administration/user-management');
        }
      } else {
        this.modalService.close(loader);
      }
    } catch (e) {
      if (e.status === 409) {
        this.modalService.openAlert(
          this.viewContainerRef,
          'Erreur',
          'Cette adresse email est déjà utilisée. Veuillez en utiliser une autre.'
        );
      }
      this.modalService.close(loader);
      throw e;
    }
  }

  private _isThereChanges(obj: any): boolean {
    return Object.keys(obj).length > 0;
  }

  async findInfoByRpps() {
    const event = this.userForm.controls.rpps.value ?? '';
    if (!event) {
      return;
    }
      const load = this.modalService.openLoading(this.viewContainerRef);
      this.isInRppsSearching = true;
      try {
        const fromLdap = (await this._annSrv.searchProfessionals({
          rpps: event
        }, 10, 0, true))?.result?.[0];
        if (this.route.snapshot.params.id && fromLdap) {
          await this._setFormAfterResearch({
            rpps: event,
            nom: fromLdap.practitionerName,
            prenom: fromLdap.firstName,
            adresse: fromLdap.address,
            codePostal: fromLdap.zip,
            commune: fromLdap.city,
            emailMSS: [fromLdap.msSanteAddress],
            codeSpecialite: fromLdap.codeSpecialite ? `${fromLdap.codeSpecialite}++${SPECIALITE_OID}` : undefined,
            codeProfession: fromLdap.codeProfession ? `${fromLdap.codeProfession}++${PROFESSION_OID}` : undefined,
          });

          if (!this._isThereChanges({...this.rppsInfo})) {
            this.modalService.openAlert(
              this.viewContainerRef, 'Aucune modification',
              'Les informations de cet utilisateur sont les mêmes que celles provenants de l\'annuaire Santé.'
            );
          }
        } else if (fromLdap) {
          this.userForm.controls.adresse.patchValue(fromLdap.address);
          this.userForm.controls.codePostal.patchValue(fromLdap.zip);
          this.userForm.controls.ville.patchValue(fromLdap.city);
          this.userForm.controls.nom.patchValue(fromLdap.practitionerName);
          this.userForm.controls.prenom.patchValue(fromLdap.firstName);
          if (fromLdap.practitionerName) {
            this.isNomFromAnn = true;
          }
          if (fromLdap?.firstName) {
            this.isPrenomFromAnn = true;
          }
          if (fromLdap?.msSanteAddress) {
            this.userForm.controls.emailMss.patchValue(fromLdap?.msSanteAddress);
            this.isAdresseMssFromAnn = true;
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.modalService.close(load);
        this.isInRppsSearching = false;
      }
  }

  public useNewValue(ctrl: FormControl, value: string, param: string) {
    ctrl.patchValue(value);
    delete this.rppsInfo[param];

    switch (param) {
      case 'rpps':
        this.isRppsFromAnn = true;
        break;
      case 'nom':
        this.isNomFromAnn = true;
        break;
      case 'prenom':
        this.isPrenomFromAnn = true;
        break;
      case 'adresse':
        break;
      case 'codePostal':
        break;
      case 'commune':
        break;
      case 'telephone':
        break;
      case 'email':
        break;
      case 'emailMSS':
        this.isAdresseMssFromAnn = true;
        break;
      case 'titre':
        break;
      case 'codeProfession':
        this.isQualiteFromAnn = true;
        delete this.rppsInfo.profession;
        break;
      case 'profession':
        break;
      case 'codeSpecialite':
        this.isSpecialiteFromAnn = true;
        delete this.rppsInfo.specialite;
        break;
      case 'specialite':
        break;
    }
  }

  private _setFormAfterResearch(infos: InfoAnnuaireExtend): void {
    const _checkMssAddress = (infoMssAddress: Array<string>, formMssAddress: string | Array<string>): boolean => {
      let rtd = true;
      if (typeof formMssAddress === 'string') {
        if (infoMssAddress.find(a => a === formMssAddress)) {
          rtd = false;
        }
      } else {
        for (const addr of infoMssAddress) {
          if (formMssAddress.find(a => a === addr)) {
            rtd = false;
            break;
          }
        }
      }
      return rtd;
    };
    const profession = infos.codeProfession ? this.qualiteValue.find(v => v.id === `${infos.codeProfession}`)?.libelle : undefined;
    const specialite = infos.codeSpecialite ? this.specialiteValue.find(v => v.id === `${infos.codeSpecialite}`)?.libelle : undefined;

    this.rppsInfo = {};

    if (infos.rpps !== this.userForm.controls.rpps.value) {
      this.rppsInfo.rpps = infos.rpps;
    } else {
      this.isRppsFromAnn = true;
    }
    if (infos.nom !== this.userForm.controls.nom.value) {
      this.rppsInfo.nom = infos.nom;
    } else {
      this.isNomFromAnn = true;
    }
    if (infos.prenom !== this.userForm.controls.prenom.value) {
      this.rppsInfo.prenom = infos.prenom;
    } else {
      this.isPrenomFromAnn = true;
    }
    if (infos.adresse !== this.userForm.controls.adresse.value) {
      this.rppsInfo.adresse = infos.adresse;
    }
    if (infos.codePostal !== this.userForm.controls.codePostal.value) {
      this.rppsInfo.codePostal = infos.codePostal;
    }
    if (infos.commune !== this.userForm.controls.ville.value) {
      this.rppsInfo.commune = infos.commune;
    }
    if (infos.codeProfession !== this.userForm.controls.qualite.value) {
      this.rppsInfo.codeProfession = infos.codeProfession;
      if (profession) {
        this.rppsInfo.profession = profession;
      }
    } else {
      this.isQualiteFromAnn = true;
    }
    if (infos.codeSpecialite !== this.userForm.controls.specialite.value) {
      this.rppsInfo.codeSpecialite = infos.codeSpecialite;
      if (specialite) {
        this.rppsInfo.specialite = specialite;
      }
    } else {
      this.isSpecialiteFromAnn = true;
    }
    if (_checkMssAddress(infos.emailMSS, this.userForm.controls.emailMss.value)) {
      this.rppsInfo.emailMSS = infos?.emailMSS ? infos?.emailMSS : undefined;
    } else {
      this.isAdresseMssFromAnn = true;
    }
  }

  async findRppsByNames() {
    const load = this.modalService.openLoading(this.viewContainerRef);
    const nom = this.userForm.controls.nom.value ?? '';
    const prenom = this.userForm.controls.prenom.value ?? '';
    this.isInRppsSearching = true;
    try {
      const infoSearch: InfoAnnuaire = {
        nom,
        prenom
      };
      const filtreAnnuaire: Filtres = {currentPage: 1, perpage: 15};
      const resultRecherche = await this._annSrv.searchAnnuaireSante(infoSearch, filtreAnnuaire);
      load.destroy();
      if (resultRecherche && resultRecherche.objects && resultRecherche.objects.length !== 0) {
        if (resultRecherche.objects.length === 1) {
          if (this.route.snapshot.params.id) {
            // this.rppsInfo = resultRecherche.objects[0];
            const obj = resultRecherche.objects[0];
            (obj as InfoAnnuaireExtend).codeProfession = `${obj.profession}++${PROFESSION_OID}`;
            (obj as InfoAnnuaireExtend).codeSpecialite = `${obj.specialite}++${SPECIALITE_OID}`;
            if (obj.rpps) {
              this.userForm.controls.rpps.patchValue(obj.rpps);
              this.isRppsFromAnn = true;
            }
            await this._setFormAfterResearch(obj);
          } else {
            const info = resultRecherche.objects[0];
            this.userForm.controls.rpps.patchValue(info.rpps);
            this.userForm.controls.qualite.patchValue(`${info.profession}++${PROFESSION_OID}`);
            this.userForm.controls.specialite.patchValue(`${info.specialite}++${SPECIALITE_OID}`);
            if (info.rpps) {
              this.isRppsFromAnn = true;
            }
            if (info.profession) {
              this.isQualiteFromAnn = true;
            }
            if (info.specialite) {
              this.isSpecialiteFromAnn = true;
            }
            this.userForm.controls.adresse.patchValue(info.adresse);
            this.userForm.controls.codePostal.patchValue(info.codePostal);
            this.userForm.controls.ville.patchValue(info.commune);
            this.userForm.controls.telephone.patchValue(this._formatTelephone(info.telephone));
            this.userForm.controls.email.patchValue(info.email);
            this.userForm.controls.categorie.patchValue(info.categorie);
            if (info.categorie) {
              this.isCategorieFromAnn = true;
            }
          }
          await this.findInfoByRpps();
        } else {
          for (const res of resultRecherche.objects) {
            res['id'] = res.rpps;
          }
          const select = this.modalService.openModalSelectList(this.viewContainerRef, 'Plusieurs résultats trouvés', this.annuaireColumnTable, resultRecherche.objects, '', resultRecherche, infoSearch, async (object: InfoAnnuaire, filtre: Filtres) => {
            const result = await this._annSrv.searchAnnuaireSante(object, filtre);
            for (const res of result.objects) {
              res['id'] = res.rpps;
            }
            return result;
          });
          const sub = select.instance.closeEmitter.subscribe(async (res) => {
            console.log(res);
            if (res) {
              if (this.route.snapshot.params.id) {
                (res as InfoAnnuaireExtend).codeProfession = `${res.profession}++${PROFESSION_OID}`;
                (res as InfoAnnuaireExtend).codeSpecialite = `${res.specialite}++${SPECIALITE_OID}`;
                if (res.rpps) {
                  this.userForm.controls.rpps.patchValue(res.rpps);
                  this.isRppsFromAnn = true;
                }
                await this._setFormAfterResearch(res);
              } else {
                const info = res;
                this.userForm.controls.rpps.patchValue(info.rpps);
                this.userForm.controls.qualite.patchValue(`${info.profession}++${PROFESSION_OID}`);
                this.userForm.controls.specialite.patchValue(`${info.specialite}++${SPECIALITE_OID}`);
                if (info.rpps) {
                  this.isRppsFromAnn = true;
                }
                if (info.profession) {
                  this.isQualiteFromAnn = true;
                }
                if (info.specialite) {
                  this.isSpecialiteFromAnn = true;
                }
                this.userForm.controls.adresse.patchValue(info.adresse);
                this.userForm.controls.codePostal.patchValue(info.codePostal);
                this.userForm.controls.ville.patchValue(info.commune);
                this.userForm.controls.telephone.patchValue(this._formatTelephone(info.telephone));
                this.userForm.controls.email.patchValue(info.email);
                this.userForm.controls.categorie.patchValue(info.categorie);
              }
              await this.findInfoByRpps();
            }
            select.destroy();
            sub.unsubscribe();
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.modalService.close(load);
      this.isInRppsSearching = false;
    }
  }

  private async submitAdmin(): Promise<string> {
    if (this.route.snapshot.params.id) {
      const user: Utilisateur = {
        id: this.route.snapshot.params.id,
        pseudo: this.userForm.controls.pseudo.value?.trim(),
        nom: this.userForm.controls.nom.value?.trim(),
        prenom: this._strUtilsSrv.uppercaseFirstCharString(this.userForm.controls.prenom.value)?.trim(),
        email: this.userForm.controls.email.value?.trim(),
        disabled: false,
        admin: this.user.admin,
      };
      await this.userService.update(user);
      return this.route.snapshot.params.id;
    } else {
      const user: CreateUtilisateur = {
        pseudo: this.userForm.controls.pseudo.value?.trim(),
        nom: this.userForm.controls.nom.value?.trim(),
        prenom: this._strUtilsSrv.uppercaseFirstCharString(this.userForm.controls.prenom.value)?.trim(),
        email: this.userForm.controls.email.value?.trim(),
        disabled: false,
        admin: true,
      };
      return await this.userService.create(user);
    }
  }

  private async submitUser(): Promise<string | undefined> {
    if (this.route.snapshot.params.id) {
      const roles: Role[] = [];
      for (let i = 0; i < this.rolesFormArray.controls.length; i++) {
        if (this.rolesFormArray.controls[i].value === true) {
          roles.push({
            id: this.roles[i].id,
            nom: this.roles[i].nom,
            droits: this.roles[i].droits,
            disabled: this.roles[i].disabled,
            espacePerso: this.roles[i].espacePerso,
            donneesMedicales: this.roles[i].donneesMedicales,
          });
        }
      }
      const qualite = this.qualiteValue.find(q => q.id === this.userForm.controls.qualite.value);
      const specialite = this.specialiteValue.find(s => s.id === this.userForm.controls.specialite.value);
      let adresseMss = this.userForm.controls.emailMss?.value;
      /**
       * Comme emailMss vient d'un formGroup
       * et qu'on ne maîtrise pas bien son type,
       * il peut parfois être une string
       * et d'autres fois un array
       * selon les situations.
       * On effectue donc des manipulations
       * selon le type.
       */
      if (typeof adresseMss === 'string') {
        adresseMss = adresseMss.trim();
      } else {
        adresseMss = adresseMss[0].trim();
      }

      const profil: Profil = {
        id: this.route.snapshot.params.id,
        idCabinet: this.route.snapshot.params.idCabinet,
        idUtilisateur: this.idUtilisateur,
        rpps: this.userForm.controls.rpps.value ? '' + this.userForm.controls.rpps.value?.trim() : undefined,
        qualiteCode: this.userForm.controls.qualite.value ? this.userForm.controls.qualite.value?.trim() : undefined,
        specialiteCode: this.userForm.controls.specialite.value ? this.userForm.controls.specialite.value?.trim() : undefined,
        adresse: this.userForm.controls.adresse.value?.trim(),
        codePostal: this.userForm.controls.codePostal.value?.trim(),
        ville: this.userForm.controls.ville.value?.trim(),
        telephone: this.userForm.controls.telephone.value ? this._formatTelephone(this.userForm.controls.telephone.value) : undefined,
        roles,
        disabled: !this.userForm.controls.actif.value,
        actif: true,
        adminCabinet: this.userForm.controls.adminCabinet.value,
        isQualiteFromAnn: this.isQualiteFromAnn,
        isRppsFromAnn: this.isRppsFromAnn,
        isSpecialiteFromAnn: this.isSpecialiteFromAnn,
        isAdresseMssFromAnn: this.isAdresseMssFromAnn,
        adresseMss,
        qualite: qualite ? qualite.libelle?.trim() : undefined,
        specialite: specialite ? specialite.libelle?.trim() : undefined,
      };

      const utilisateur: Utilisateur = {
        id: this.idUtilisateur,
        pseudo: this.user.pseudo?.trim(),
        nom: this.userForm.controls.nom.value?.trim(),
        prenom: this._strUtilsSrv.uppercaseFirstCharString(this.userForm.controls.prenom.value)?.trim(),
        email: this.userForm.controls.email.value?.trim(),
        disabled: !this.userForm.controls.actif.value,
        admin: this.user.admin,
        isNomFromAnn: this.isNomFromAnn,
        isPrenomFromAnn: this.isPrenomFromAnn,
        categorie: this.userForm.controls.categorie?.value ? this.userForm.controls.categorie.value : undefined,
      };

      if (!profil.rpps) {
        delete profil.rpps;
      }
      if (!profil.qualite) {
        delete profil.qualite;
      }
      if (!profil.specialite) {
        delete profil.specialite;
      }

      await this.userService.update(utilisateur);
      await this.profilService.update(profil);

      return this.route.snapshot.params.id;
    } else {
      const user: CreateUtilisateur = {
        pseudo: this.userForm.controls.pseudo.value?.trim(),
        nom: this.userForm.controls.nom.value?.trim(),
        prenom: this._strUtilsSrv.uppercaseFirstCharString(this.userForm.controls.prenom.value)?.trim(),
        email: this.userForm.controls.email.value?.trim(),
        disabled: !this.userForm.controls.actif.value,
        admin: false,
        isNomFromAnn: this.isNomFromAnn,
        isPrenomFromAnn: this.isPrenomFromAnn,
        categorie: this.userForm.controls.categorie?.value
      };
      let id = '';
      try {
        id = await this.userService.create(user);
        if (!id) {
          throw new Error('Erreur lors de la création de l\'utilisateur');
        }
      } catch (res) {
        if (res.status === 409) {
          id = res.error;
          const continueCreation = await new Promise<boolean>((resolve) => {
            const modalConfim = this.modalService.openModalConfirmation(
              this.viewContainerRef,
              'Utilisateur déjà existant',
              'Un utilisateur, lié à un autre cabinet, existe déjà avec cette adresse mail.\n\nSi vous continuez, un profil rattaché à cet utilisateur sera créé et lié à ce cabinet (il restera également lié à l\'autre cabinet).\n\nSouhaitez-vous continuer ?',
            ) as ComponentRef<ConfirmationMessageFragment>;
            const sub = modalConfim.instance.closeEmitter.subscribe(async (res) => {
              sub.unsubscribe();
              modalConfim.destroy();
              resolve(!!res);
            });
          });
          if (!continueCreation) {
            return;
          }
        } else {
          throw res;
        }
      }
      const roles: Role[] = [];
      for (let i = 0; i < this.rolesFormArray.controls.length; i++) {
        if (this.rolesFormArray.controls[i].value === true) {
          roles.push({
            id: this.roles[i].id,
            nom: this.roles[i].nom,
            droits: this.roles[i].droits,
            disabled: this.roles[i].disabled,
            espacePerso: this.roles[i].espacePerso,
            donneesMedicales: this.roles[i].donneesMedicales,
          });
        }
      }
      const qualite = this.qualiteValue.find(q => q.id === this.userForm.controls.qualite.value);
      const specialite = this.specialiteValue.find(s => s.id === this.userForm.controls.specialite.value);
      const profil: CreateProfil = {
        idCabinet: this.route.snapshot.params.idCabinet,
        idUtilisateur: id,
        rpps: this.userForm.controls.rpps.value ? '' + this.userForm.controls.rpps.value?.trim() : undefined,
        qualiteCode: this.userForm.controls.qualite.value ? this.userForm.controls.qualite.value?.trim() : undefined,
        specialiteCode: this.userForm.controls.specialite.value ? this.userForm.controls.specialite.value?.trim() : undefined,
        adresse: this.userForm.controls.adresse.value?.trim(),
        codePostal: this.userForm.controls.codePostal.value?.trim(),
        ville: this.userForm.controls.ville.value?.trim(),
        telephone: this.userForm.controls.telephone.value ? this._formatTelephone(this.userForm.controls.telephone.value) : undefined,
        roles,
        disabled: false,
        actif: this.userForm.controls.actif.value,
        adminCabinet: this.userForm.controls.adminCabinet.value,
        isQualiteFromAnn: this.isQualiteFromAnn,
        isRppsFromAnn: this.isRppsFromAnn,
        isSpecialiteFromAnn: this.isSpecialiteFromAnn,
        isAdresseMssFromAnn: this.isAdresseMssFromAnn,
        adresseMss: this.userForm.controls.emailMss?.value?.trim(),
        qualite: qualite ? qualite.libelle?.trim() : undefined,
        specialite: specialite ? specialite.libelle?.trim() : undefined,
        categorie: this.userForm.controls.categorie?.value ? this.userForm.controls.categorie.value : undefined,
      };

      if(!profil.rpps) {
        delete profil.rpps;
      }
      if (!profil.qualite) {
        delete profil.qualite;
      }
      if (!profil.specialite) {
        delete profil.specialite;
      }
      return await this.profilService.create(profil);
    }
  }

  public goToFeaturesManagment(): void {
    if (this.profilId) {
      this.router.navigateByUrl(`/administration/feature-flipping?type=${FeatureType.PROFIL}&id=${this.profilId}`);
    }
  }

  public async unlockCguValidation(): Promise<void> {
    const loading = this.modalService.openLoading(this.viewContainerRef);
    try {
      await this._cguSrv.saveCguDecision(this.idUtilisateur, DecisionStateEnum.ResetAdmin);
      await this._initHistoriqueDecisionsCgu();
    } catch {
      this.modalService.openAlert(this.viewContainerRef, 'Erreur', 'Une erreur est survenue lors de la modification du statut des CGU.');
    } finally {
      loading.destroy();
    }
  }
}
